/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для условий доставки Сима-ленд.
   * @param {app.SettlementForm} settlement Модель формы города
   * @param {app.Collection} collection Коллекция для информации о доставке
   */
  app.DeliveryConditionView = app.View.extend({
    el: '.info-delivery-simaland-view',
    events: {
      'click .payment-dates-list .ui-menu-item': 'refreshDeliveryConditions',
    },
    additionalOptions: ['currency'],
    MIN_ITEM_PRICES_FOR_REMOTE_DELIVERY: 1000,
    /** @inheritDoc */
    run: function () {
      this.minItemPricesForRemoteDelivery = app.helpers.CurrencyConverter
        .performConvert(this.MIN_ITEM_PRICES_FOR_REMOTE_DELIVERY, this.currency.rate);
      this.infoDeliveryCommentTemplate = app.helpers.TemplateHelper.getTemplate('#info-delivery-comment-template');
      this.settlement.expand = 'expand=settlement_ext,has_active_jp_purchase,districts';
      this.collection.urlRoot = app.entryScriptName + '/api/v4/delivery-info';
      this.tableTemplate = app.helpers.TemplateHelper.getTemplate('#delivery-condition-template');
      this.commentTemplate = app.helpers.TemplateHelper.getTemplate('#delivery-comments-template');
      this.paymentDatesTemplate = app.helpers.TemplateHelper.getTemplate('#delivery-payment-dates-template');
      this.minSumCommentTemplate = app.helpers.TemplateHelper.getTemplate('#info-delivery-min-sum-comment-template');
      this.settlement.save();
      this._initEventListeners();
    },

    /**
     * Инициализация слушателей событий.
     * @private
     */
    _initEventListeners: function () {
      this.listenTo(this.settlement, 'sync', this.fetchDeliveryInfo);
      this.listenTo(this.collection, 'sync', this.onCollectionSync);
    },

    /**
     * Получение данных о доставке.
     * @param data
     */
    fetchDeliveryInfo: function (data) {
      var payload = { settlement_id: this.settlement.get('settlement_id') };
      if (!(data instanceof app.SettlementForm)) {
        payload = _.merge(payload, data);
      }
      this.collection.fetch({
        data: $.param(payload),
      });
      this.$('.js-payment-time-before').addClass('not_display');
    },

    /**
     * Возвращает признак удаленной доставки.
     * @return {boolean} признак удаленной доставки.
     */
    getWithRemoteItems: function () {
      return _.some(this.collection.toJSON(), function (deliveryGroup) {
        return _.some(_.get(deliveryGroup, 'conditions', {}), { is_remote_only: true });
      });
    },

    /**
     * Инициализация попапа выбора даты оплаты после отрисовки страницы
     */
    onCollectionSync: function () {
      this.render();
      this.initPopup();
    },

    /** @inheritDoc */
    render: function () {
      var data = {
        isMobile: app.isMobile,
        isPaidDelivery: this.settlement.get('is_paid_delivery'),
        isTypesetting: this.settlement.get('is_typesetting'),
        deliveryGroups: this.collection.toJSON(),
        formatPrice: this.formatPrice,
        isSmallWholesale: this.settlement.get('is_small_wholesale'),
        minOrderSum: this.settlement.get('min_order_sum'),
        minItemPricesForRemoteDelivery: this.minItemPricesForRemoteDelivery,
      };
      this.$('.js-delivery-condition').html(data.deliveryGroups.length && !this.settlement.get('is_paid_delivery')
        ? this.tableTemplate(data)
        : ''
      );
      this.renderComments(data);
      this.renderCostComments();
      if (this.collection.paymentDates.length) {
        var $beforeDateText = this.$('.js-payment-date-before-text');
        var $afterDateText = this.$('.js-payment-date-after-text');
        var selectedDate = _.find(this.collection.paymentDates, function (date) {
          return date.active;
        });
        this.$('.js-payment-date-title').html(this.paymentDatesTemplate(this.collection));
        this.$('.js-payment-before-text').removeClass('not_display');
        $beforeDateText.text(_.isNumber(selectedDate.timestamp) ? 'при заказе до' : 'при заказе');
        $afterDateText.toggleClass('not_display', !_.isNumber(selectedDate.timestamp));
      } else {
        this.$('.js-payment-before-text').addClass('not_display');
      }
    },

    /**
     * Преобразовать цену в нужный формат
     * @param {number} value Цена
     * @returns {string}
     */
    formatPrice: function (value) {
        var fractionPrice = app.helpers.NumberHelper.numberWithoutZeroFraction(value);
        return fractionPrice.join('.');
    },

    /**
     * Инициализация попапа выбора даты оплаты
     */
    initPopup: function () {
      this.popup = new als.Popup($('.js-payment-dates-list'), $('.js-payment-date-title'));
    },

    /**
     * Обновляем таблицу после выбора даты оплаты
     * @param {Event} event
     */
    refreshDeliveryConditions: function (event) {
      var data = {};
      var timestamp = this.$(event.currentTarget).data('timestamp');
      if (timestamp) {
        data.payment_timestamp = timestamp;
      }
      this.fetchDeliveryInfo(data);
    },

    /**
     * Отрисовка комментариев относящиеся к стоимости заказа.
     */
    renderCostComments: function() {
      var $wrapper = this.$('.js-cost-comment');
      var isSmallWholesale = this.settlement.get('is_small_wholesale');
      var hasActiveJp = this.user && this.settlement && this.settlement.get('has_active_jp_purchase');
      var minOrderSum = this.settlement.get('min_order_sum');
      var commentsConfig = {
        deliveryMinSum: !hasActiveJp && minOrderSum > 1,
        withLessThanMinOrderSumAndMinItemPricesForRemote: false,
        withGreaterThanMinItemPricesForRemote: false,
      };
      // Возвращает признак показа блока (есть ли вообще комментарии).
      var getIsCommentsInside = function () {
        return _.some(commentsConfig, function(val) {
          return val;
        });
      };
      this.collection.each(function (deliveryGroup) {
        var conditions = deliveryGroup.get('conditions');
        _.merge(commentsConfig, this.costCommentBlockParams(conditions));
      }.bind(this));
      if (!this.settlement.get('is_paid_delivery')
        && (!hasActiveJp || !isSmallWholesale || minOrderSum > 1)
        && getIsCommentsInside()
      ) {
        $wrapper
          .html(this.minSumCommentTemplate(_.assign({
            fractionPrice: app.helpers.NumberHelper.fractionNumber,
            minSum: minOrderSum,
            currentCurrency: this.currency.sign,
            withRemoteComment: this.getWithRemoteItems(),
            minItemPricesForRemoteDelivery: this.minItemPricesForRemoteDelivery,
          }, commentsConfig)))
          .removeClass('not_display');
      } else {
        $wrapper.addClass('not_display');
      }
    },

    /**
     * Данные для отрисовки блоков комментариев.
     * @param {array} conditions Кондиции
     * @returns {object}
     */
    costCommentBlockParams: function(conditions) {
      var commentsConfig = {};
      conditions.forEach(function (condition) {
          if (condition.is_remote_only) {
            commentsConfig.withLessThanMinOrderSumAndMinItemPricesForRemote = true;
          }
          if (condition.is_min_sum_small_wholesale) {
            commentsConfig.withGreaterThanMinItemPricesForRemote = true;
          }
      });

      return commentsConfig;
    },

    /**
     * Отрисовка блока с комментариями
     * @param data
     */
    renderComments: function (data) {
      var comments = [];
      var templateHelper = app.helpers.TemplateHelper;
      var settlementExt = this.settlement.get('settlement_ext') || {};
      var hasDeliveryDirection = _.isNumber(settlementExt.delivery_direction_id);
      if (data.deliveryGroups.length) {
        if (data.isPaidDelivery) {
          comments.push(templateHelper.getTemplate('#paid-delivery-comment-template')());
        } else {
          if (data.isTypesetting) {
            comments.push(templateHelper.getTemplate('#typesetting-comment-template')());
          } else {
            comments.push(templateHelper.getTemplate('#delivery-price-comment-template')());
            var justPickup = true;
            data.deliveryGroups.forEach(function (deliveryGroup) {
              if (!deliveryGroup.is_pickup) {
                justPickup = false;
              }
            });
            var toDayDelivery = data.deliveryGroups.some(function (item) {
              return item.has_today_markup;
            });
            if (toDayDelivery) {
              comments.push(templateHelper.getTemplate('#delivery-date-to-date-template')());
            }
            if (!justPickup) {
              comments.push(templateHelper.getTemplate('#expeditor-comment-template')());
            }
          }
        }
      } else {
        comments.push(app.helpers.TemplateHelper.getTemplate('#no-delivery-comment-template')());
      }
      this.$('.js-info-delivery-comment')
        .html(this.infoDeliveryCommentTemplate({
          is_delivery_to_entrance: Boolean(settlementExt.is_delivery_to_entrance),
          deliveryTextComment: this.collection.deliveryText,
          fractionPrice: app.helpers.NumberHelper.fractionNumber,
        }))
        .toggleClass('not_display', !(data.deliveryGroups.length || hasDeliveryDirection));
      if (comments.length) {
        this.$('.js-comments')
          .html(this.commentTemplate({
            comments: comments,
          }))
          .removeClass('not_display');
      }
    },
  });
})(jQuery);

}.call(window));